function BrandList(){
  const brandsLetters = document.querySelectorAll('.brands .brands__letterlink[data-letter]');
  const brandsAnchors = document.querySelectorAll('.brands .brands__letteranchor[data-letter]');
  const brandImages = document.querySelectorAll('.brands .brands__imagewrapper[data-handle]');
  const brandLinks = document.querySelectorAll('.brands .brands__brand [data-handle]');

  function onLetterIntersection(entries, observer){
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const letter = entry.target.getAttribute('data-letter');
        brandsLetters.forEach((brandLetter) => {
          if(brandLetter.getAttribute('data-letter') === letter){
            brandLetter.classList.add('brands__letterlink--active');
          } else{
            brandLetter.classList.remove('brands__letterlink--active');
          }
        });
      }
    });
  }


  function init(){
    const observer = new IntersectionObserver(onLetterIntersection, {
      threshold: 0.8
    });
    brandsAnchors.forEach((brandAnchor) => {
      observer.observe(brandAnchor);
    });

    brandsLetters.forEach((brandLetter) => {
      brandLetter.addEventListener('click', (e) => {
        if(e.target.hasAttribute('data-letter')){
          const relatedBrandAnchor = Array.from(brandsAnchors).find((brandAnchor) => brandAnchor.getAttribute('data-letter') === e.target.getAttribute('data-letter'));
          if(relatedBrandAnchor){
            e.preventDefault();
            relatedBrandAnchor.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }
        }
      })
    });

    const viewWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if (viewWidth > 999){
      brandLinks.forEach((brandLink) => {
        brandLink.addEventListener('mouseover', (event) => {
          if(event.target.hasAttribute('data-handle')){
            brandImages.forEach((brandImage) => {
              if(brandImage.getAttribute('data-handle') === event.target.getAttribute('data-handle')){
                brandImage.removeAttribute('hidden');
              } else{
                brandImage.setAttribute('hidden', true);
              }
            })
          }
        })
      });
    }
  }

  init();
}


document.addEventListener('DOMContentLoaded', (e)=>{
  BrandList();
})